<template>
  <div>
    <div
      v-if="showLoader"
      class="spinner-border"
      style="margin: auto; display: block"
    ></div>
    <table
      class="table"
      v-if="automationList.length != 0 && !showLoader"
      style="table-layout: fixed"
    >
      <thead>
        <tr>
          <th width="8%">Status</th>
          <th width="20%">Title</th>
          <th width="20%">Attributes</th>
          <th width="10%">Schedule</th>
          <th width="25%">Action</th>
          <th width="7%">Scope</th>
          <th width="8%">Created</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-bind:class="[
            { rule_wrapper: false && !automation.active },
            { even: index % 2 == 0 },
          ]"
          v-for="(automation, index) in automationList"
          :key="'automationList_1_' + index"
          @mouseenter="
            !ispopUpOpenend
              ? (showByIndex = index)
              : (showByIndex = indexToShowOnPopUpClick)
          "
          @mouseleave="
            !ispopUpOpenend
              ? (showByIndex = null)
              : (showByIndex = indexToShowOnPopUpClick)
          "
          @mouseover="tooltipCode()"
        >
          <template
            v-if="automation.showGuardRailLoader"
          >
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <div
              class="spinner-border"
              style="margin: auto; display: block"
            ></div>
            <td></td>
          </template>
          <template v-else>
            <!-- status -->
            <td>
              <div
                v-if="forceRender"
                :id="index"
                style="
                  height: 15.95px;
                  width: 15.95px;
                  border-radius: 20px;
                  margin-left: 15px;
                  cursor: pointer;
                "
                @mouseover="tooltipCode()"
                :class="setStateColor(automation,index)"
                data-toggle="tooltip"
                :title="setTooltipState(automation)"
                data-placement="bottom"
              ></div>
            </td>
            <!-- title -->
            <td style="line-height: 19px">
              <p
                v-if="automation.active"
                style="text-transform: capitalize; margin-bottom: 0px;margin-top:-2.5px"
              >
                {{ automation.title }}
              </p>
              <p v-else style="text-transform: capitalize; margin-bottom: 0px;margin-top:-2.5px">
                {{ automation.title }}
              </p>
              <p
                style="font-size: 12px;
                line-height: 14px;
                margin-bottom: 0px;
                margin-top:1px;
                letter-spacing: -0.05px;"
                v-if="automation.created_by"
              >
                <i
                  ><span style="font-weight: 700">Created By</span>
                  {{ automation.created_by }}</i
                >
              </p>
            </td>
            <!-- attributes -->
            <td style="line-height: 16px">
              <span style="automation">
                <span style="font-weight: 700">Target: </span>
                <span>{{
                  JSON.parse(automation.target || "{}").name || ""
                }}</span>
              </span>
              <p
                v-for="(condition, conditionIndex) in automation.trigger"
                :key="'triggerList' + index + '_' + conditionIndex"
                :style="(automation&&automation.trigger&&automation.trigger.length>1) ? 'color:rgba(51,51,51,0.75)':''"
                style="margin-top:2px;margin-bottom: 0px; padding-bottom: 0px; font-size: 12px;letter-spacing:-0.05px"
              >
                <span v-if="condition.trigger != 'undefined'">
                  <span style="display: inline-block">
                    <span v-if="conditionIndex != 0" style="font-weight: 700">{{
                      condition && condition.operation_type
                        ? condition.operation_type == "AND"
                          ? "AND"
                          : condition.operation_type
                        : ""
                    }}</span>
                    <span>
                      {{
                        condition.trigger
                          ? JSON.parse(condition.trigger).type.name
                          : ""
                      }}
                    </span>
                    <span style="font-weight: 700">{{
                      getCondition(JSON.parse(condition.trigger))
                    }}</span>
                    <span>
                      {{ getValue(JSON.parse(condition.trigger)) }}
                    </span>
                    <span
                      v-if="
                        JSON.parse(condition.trigger).condition.id ==
                          'range' ||
                        JSON.parse(condition.trigger).condition.id ==
                          'notinrange'
                      "
                      >,
                      {{
                        condition.trigger
                          ? JSON.parse(condition.trigger).value2
                            ? JSON.parse(condition.trigger).value2
                            : ""
                          : ""
                      }}</span
                    >
                    <span v-show="JSON.parse(condition.trigger).attribute">
                      of
                      {{
                        condition.trigger
                          ? JSON.parse(condition.trigger).attribute
                            ? JSON.parse(condition.trigger).attribute.name
                            : ""
                          : ""
                      }}</span
                    >
                  </span>
                </span>
              </p>
            </td>
            <!-- schedule -->
            <td style="line-height: 14px">
              <span style="font-weight: 700">
                {{ JSON.parse(automation.execute_on || "{}").name || "" }}
              </span>
              <br />
              <span style="font-size: 12px;letter-spacing:-0.05px">{{
                JSON.parse(automation.execution_time).length
                  ? getexecutionTimeVal(automation.execution_time, automation)
                  : ""
              }}</span>
            </td>
            <!-- action -->
            <td style="line-height: 19px">
              <p
                v-for="(action, actionIndex) in automation.actions"
                :key="'actionList' + index + '_' + actionIndex"
                style="margin-bottom: 0px; padding-botton: 0px"
              >
                <span style="display: inline-block" v-if="actionIndex < 3">
                  <span style="font-weight: 700">{{
                    action.title ? action.title + " " : ""
                  }}</span>
                  <span v-if="action.entity_type != 'multiselect'">{{
                    action.value ? action.value : ""
                  }}</span>
                  <span v-else>
                    <span
                      v-for="(multiValues, multiValueIndex) in JSON.parse(
                        action.value
                      )"
                      :key="'multiValuesList' + index + '_' + multiValueIndex"
                      style="display: inline-block"
                      >{{ multiValues.name
                      }}<span
                        v-if="
                          JSON.parse(action.value).length - 1 != multiValueIndex
                        "
                        >,</span
                      ></span
                    >
                  </span>
                </span>
                <span v-else-if="actionIndex >= 3"
                  ><span style="font-weight: 700">+ </span>More</span
                >
              </p>
            </td>
            <!-- scope -->
            <td style="line-height:19px">
              <span
                v-if="
                  automation &&
                  automation.scopeList &&
                  automation.scopeList.length
                "
                >Set</span
              >
              <span v-else>
                <div
                  style="
                    height: 13px;
                    width: 13px;
                    border-radius: 20px;
                    display: inline-block;
                  "
                  class="draft_color"
                ></div><span>
                Missing</span>
                </span
              >
            </td>
            <!-- created -->
            <td style="line-height:19px">
              {{ formatCreatedDate(automation.created_on) }}
            </td>
            <!-- sub menu -->
            <td>
              <div class="row-add-edit">
                <a
                  href="javascript:void(0)"
                  class="item-add-edit"
                  data-toggle="dropdown"
                ></a>
                <div
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                  style="left: -58px"
                >
                  <a
                    class="grid-item ico-edit"
                    @click="openAddEditAutomation(index)"
                    v-if="automation.active"
                    >Edit</a
                  >
                  <a
                    class="grid-item ico-power-off"
                    @click="inputIsactiveRule(automation, index)"
                    v-if="automation.active"
                    >Disable Guardrail</a
                  >
                  <a
                    class="grid-item ico-power-off"
                    @click="inputIsactiveRule(automation, index)"
                    v-else
                    >Enable Guardrail</a
                  >
                  <a
                    class="grid-item ico-delete"
                    @click="
                      deleteAutomation(automation.id, index, automation.title)
                    "
                    >Delete Guardrail</a
                  >
                </div>
              </div>
            </td>
          </template>
        </tr>
        <AssociateAutomation
          v-if="callAssociateModal"
          @toggleModal="toggleModal"
          @deleteScopeUpdation="deleteScopeUpdation"
          @editScope="editScope"
          @saveScope="saveScope"
          :automationId="associateAutomationId"
          :automationIndex="automationIndex"
          :target="automationTarget"
          ref="associateAutomationTo"
        />
      </tbody>
    </table>

    <AddEditAutomation
      v-if="callAddEditModal"
      @toggleModal="toggleModal"
      :editCondition="editCondition"
      :automationId="editAutomationId"
      :editConditionRow="editConditionRow"
      :editConditionTarget="editConditionTarget"
      ref="editAutomation"
    />

    <ShowScope
      v-if="callScopeModal"
      :automationId="editAutomationId"
      @toggleModal="toggleModal"
    />
    <DeleteSingleProductConfirmModal
      v-if="!confirmisActive"
      @deleteSelectedProducts="deleteAction"
      @hideAction="hideAction"
      :notDeleted="false"
      :delHeaderMsg="updateHeading(guardrailName)"
    ></DeleteSingleProductConfirmModal>
    <ScopeEnableDisablePopUp
      @deleteSelectedProducts="disableActiveRule"
      @closeActiveRuleModal="closeActiveRuleModal"
      :notDeleted="false"
      delHeaderMsg="Enable/Disable Guardrail"
      :isDiffMsg="disablePopUpMsg"
    ></ScopeEnableDisablePopUp>
    <ShowDetailedScope
      :target="selectedShowMoreScopeTarget"
      :data="selectedShowMoreScopeData"
    />
    <SelectTemplate
      :templateSelected="templateSelected"
      :oldTemplate="oldTemplate"
      @closeSelecTemplate="closeTemplateModal"
    />

    <PreviewTemplate
      :previewTemplateData="previewTemplateData"
      @closePopUp="closePopUp"
    />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ActionsAutomation from "@/components/Automation2/ActionsAutomation.vue";
import ConditionsAutomation from "@/components/Automation2/ConditionsAutomation.vue";
import AddEditAutomation from "@/components/Automation2/AddEditAutomation2.vue";
import ScopeEnableDisablePopUp from "@/components/Automation2/ScopeEnableDisablePopUp.vue";
import AssociateAutomation from "@/components/Automation2/AssociateAutomation.vue";
import DeleteSingleProductConfirmModal from "@/components/product/DeleteSingleProductConfirmModal";
import ShowScope from "@/components/Automation2/ShowScope.vue";
import ShowDetailedScope from "@/components/Automation2/ShowDetailedScope.vue";
import SelectTemplate from "@/components/Automation2/SelectTemplate.vue";
import moment from "moment";
import PreviewTemplate from "@/components/templates/PreviewTemplate.vue";
import Template from "../templates/Template.vue";

export default {
  name: "AutomationList",
  components: {
    Multiselect,
    AddEditAutomation,
    AssociateAutomation,
    ActionsAutomation,
    DeleteSingleProductConfirmModal,
    ConditionsAutomation,
    ShowScope,
    ScopeEnableDisablePopUp,
    ShowDetailedScope,
    SelectTemplate,
    PreviewTemplate,
    Template,
  },
  props: ["automationList", "actionList", "conditionList"],
  data() {
    return {
      forceRender:true,
      countryList: [],
      guardrailName: "",
      guardRailId: -1,
      typeList: [],
      callChild: false,
      editConditionRow: "",
      editCondition: false,
      editConditionTarget: "",
      callActionModal: false,
      callAssociateModal: false,
      callAddEditModal: false,
      preFilledTypeList: [],
      callAddEditConditionModal: false,
      currentIndex: -1,
      currentActionIndex: -1,
      currentConditionIndex: -1,
      editAutomationId: "",
      associateAutomationId: "",
      automationTarget: "",
      showByIndex: null,
      idDelActionModal: false,
      actionToEdit: "",
      actionToDel: -1,
      showLoader: false,
      addCondition: false,
      conditionRowId: "",
      showByIndexAction: -1,
      showByIndexCondition: null,
      actionToDel: -1,
      showLoader: false,
      conditionRowId: "",
      showByIndexCondition: null,
      callScopeModal: false,
      currentActionIndex: -1,
      currentSelectedIndex: -1,
      currentConditionIndex: -1,
      showDelLoader: false,
      ispopUpOpenend: false,
      indexToShowOnPopUpClick: -1,
      isEditConditionPopOver: false,
      isActionConditionConditinPopOver: false,
      showByIndexCondition: -1,
      isShowActionEditPopOver: false,
      showByIndexAction: -1,
      showActionIndexPopOver: -1,
      editConditionSelected: -1,
      isactiveRule: true,
      confirmisActive: false,
      automationToDisableIndex: -1,
      ruleToggleValue: {},
      disablePopUpMsg: "",
      valueToToggleRulePopUp: false,
      oldActionTypeList: [],
      automationIndex: -1,
      selectedShowMoreScopeTarget: "",
      selectedShowMoreScopeData: [],
      operationType: "",
      templateSelected: "",
      selectedTemplateIndex: -1,
      oldTemplate: "",
      previewTemplateData: {},
    };
  },
  mounted() {
    this.$store.dispatch("callAnalytics", {
      data: window.location.href,
      this: this,
      type: "automationList",
    });
    this.getCountryCodeList();
    this.preventCloseOnOutsideClk();
    this.tooltipCode()
  },
  computed: {
    isEdit: {
      get() {
        return this.$store.state.isEdit;
      },
    },
  },
  methods: {
    moment,
    tooltipCode() {
      // $(document).ready(function () {
      //   $('[data-toggle="tooltip"]').tooltip({
      //       template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
      //   })
      // });
      $('[data-toggle="tooltip"]').tooltip();
    },
    formatCreatedDate(data) {
      return moment(data).format("MM/DD/YYYY");
    },
    setTooltipState(automation) {
      if (
        (automation && automation.active && automation.active == true) && 
        (
          (!automation.scopeList || !automation.scopeList.length) ||
          (automation && (!automation.actions || !automation.actions.length))
        )
        ){
        return "Draft";
      } else if (automation && automation.active && automation.active == true) {
        return "Enabled";
      } else {
        return "Disabled";
      }
    },
    setStateColor(automation,index) {
      if (
        (automation && automation.active && automation.active == true) && 
        (
          (!automation.scopeList || !automation.scopeList.length) ||
          (automation && (!automation.actions || !automation.actions.length))
        )
        ){
        return "draft_color";
      } else if (automation && automation.active && automation.active == true) {
        return "active_color";
      } else {
        return "disabled_color";
      }
    },
    getCountryCodeList() {
      let vm = this;
      this.$store.dispatch("accounts/getCountryList").then((res) => {
        vm.countryList = res;
        let data = vm.countryList.find((e) => e.market_place == "US");
        let index = vm.countryList.indexOf(data);
        vm.countryList.splice(index, 1);
        vm.countryList.unshift(data);
      });
    },
    hideAction() {
      this.guardrailName = "";
    },
    updateHeading(data) {
      if (data && data != "") {
        data = 'Delete "' + data + '"';
        return data;
      } else {
        return "Delete";
      }
    },
    getCondition(trigger) {
      var sign = trigger.condition.id||trigger.condition.name;
      var con = "";
      switch (sign) {
        case "=":
          con = "Is equal to";
          break;
        case ">":
          con = "Is greater than";
          break;
        case "<":
          con = "Is less than";
          break;
        case "range":
          con = "Is in Range of";
          break;
        default:
          con = trigger.condition.name;
      }
      return con;
    },
    openNewTab(data) {
      let newWindow = window.open(data, "_blank");
    },
    showISComma(index, data) {
      let parsedData = JSON.parse(data);
      if (index <= parsedData.length - 2) {
        return ", ";
      } else {
        return "";
      }
    },
    getValue(trigger) {
      var type = typeof trigger.value;
      var arr = [];
      if (type == "string") {
        return trigger.value;
      } else {
        if (trigger && trigger.type && trigger.type.id == "country") {
          for (var i = 0; i < trigger.value.length; i++) {
            arr.push(trigger.value[i].country_code);
          }
        } else {
          for (var i = 0; i < trigger.value.length; i++) {
            arr.push(trigger.value[i].name);
          }
        }
      }
      return arr.join(",	");
    },
    preventCloseOnOutsideClk() {
      $(".editC").on("hide.bs.dropdown", function (e) {
        if (e.clickEvent) {
          e.preventDefault();
        }
      });
      $(".addC").on("hide.bs.dropdown", function (e) {
        if (e.clickEvent) {
          e.preventDefault();
        }
      });
      $(".addA").on("hide.bs.dropdown", function (e) {
        if (e.clickEvent) {
          e.preventDefault();
        }
      });
      $(".editA").on("hide.bs.dropdown", function (e) {
        if (e.clickEvent) {
          e.preventDefault();
        }
      });
    },
    inputIsactiveRule(automation, index) {
      this.valueToToggleRulePopUp = automation.active ? false : true;
      // this.valueToToggleRulePopUp = e;
      this.confirmisActive = true;
      this.automationToDisableIndex = index;
      this.ruleToggleValue = automation;
      if (this.valueToToggleRulePopUp) {
        this.disablePopUpMsg = "Are you sure you want to Enable Guardrail?";
      } else {
        this.disablePopUpMsg = "Are you sure you want to Disable Guardrail?";
      }
      //To open confirmation model for enable/disable guardrail
      this.$nextTick(() => {
        window.$("#confirmScopeEnableDisablePopUp").modal({
          show: true,
        });
        window
          .$("#confirmScopeEnableDisablePopUp")
          .on("hide.bs.modal", function (e) {
            e.stopImmediatePropagation();
          });
      });

      //Below line was creating some problem wrt opening of modal.
      //$("#confirmScopeEnableDisablePopUp").modal("show");
    },
    disableActiveRule() {
      let toggleAutomation = this.valueToToggleRulePopUp;
      //	this.automationList[this.automationToDisableIndex].active = toggleAutomation
      let payload = { active: toggleAutomation, id: this.ruleToggleValue.id };
      let vm = this;
      this.$store.dispatch("automation/setRowInactive", payload).then((res) => {
        vm.confirmisActive = false;
        if (res) {
          vm.automationList[vm.automationToDisableIndex].active =
            vm.valueToToggleRulePopUp;
        }
        vm.forceRender = false;
        vm.$nextTick(()=>{
          vm.forceRender = true
          
          vm.tooltipCode();
        })
        vm.automationList.splice(0,0)
      });
    },
    closeActiveRuleModal() {
      this.automationList[this.automationToDisableIndex].active =
        !this.valueToToggleRulePopUp;
    },
    setHoverSelected(data) {
      this.ispopUpOpenend = data;
    },
    formatCreatedOnDate(item) {
      item = item.replace(/\"/g, "");
      // let isDoubleQuotes = item.indexOf('""')
      // if(isDoubleQuotes>-1){
      // 	item.slice(1,(item.length-1))
      // }
      let dateToFormat = this.convertUTCDateToLocalDate(new Date(item));

      let formated = moment(dateToFormat).format("MM/DD/YYYY");

      return formated;
    },
    convertUTCDateToLocalDate(date) {
      var newDate = new Date(
        date.getTime() + date.getTimezoneOffset() * 60 * 1000
      );
      var offset = date.getTimezoneOffset() / 60;
      var hours = date.getHours();
      newDate.setHours(hours - offset);
      return newDate;
    },
    formatDate(date) {
      //
      //	date = new Date(date - date.getTimezoneOffset() * 60000);
      // date = Date.UTC(date)
      //date = this.convertUTCDateToLocalDate(new Date(date))
      let todaysDateFormatted = moment().local().format("L");
      let todaysDate = moment().local();
      let newDateFormatted = moment(date).local().format("L");
      let newDate = moment(date, "YYYY-MM-DDTHH:mm");

      let yesterday = moment(new Date()).add(-1, "days").format("L");

      if (newDateFormatted == todaysDateFormatted) {
        //	let diffHrs = moment(newDate).fromNow()
        return "today";
      } else if (newDateFormatted == yesterday) {
        return "yesterday";
      } else {
        var daysDiff = todaysDate.diff(newDate, "days");
        if (daysDiff > 1) return daysDiff + " days ago";
        else return daysDiff + " day ago";
      }
    },
    convertUTCDateToLocalDate(date) {
      var newDate = new Date(
        date.getTime() + date.getTimezoneOffset() * 60 * 1000
      );
      var offset = date.getTimezoneOffset() / 60;
      var hours = date.getHours();
      newDate.setHours(hours - offset);
      return newDate;
    },
    deleteAutomation(guardRailId, index, title) {
      this.currentSelectedIndex = index;
      this.guardRailId = guardRailId;
      this.guardrailName = title;
      console.log('Delete Guardrail with parameter ? : Guardrail Id ',guardRailId)
      $("#confirmSingleDeleteProduct").modal("show");
    },
    enableOther() {
      this.isShowActionEditPopOver = false;
    },
    updateAutomationList(data) {
      if (data.isEdit == true) {
        var index = this.$store.state.automation.automationList[
          data.ind
        ].actions.findIndex((item) => item.id === data.actionData.id);
        this.$store.state.automation.automationList[data.ind].actions.splice(
          index,
          1,
          data.actionData
        );
        //
        // if(data.actionData.template_name && data.actionData.template_id){
        // 	this.$store.state.automation.automationList[data.ind].template_name = data.actionData.template_name
        // 	this.$store.state.automation.automationList[data.ind].template_id = data.actionData.template_id
        // }
      } else {
        let vm = this;
        data.actionData.forEach((action) => {
          console.log(action);

          // if(action.template_name && action.template_id){
          // 	vm.$store.state.automation.automationList[data.ind].template_name = action.template_name
          // 	vm.$store.state.automation.automationList[data.ind].template_id = action.template_id
          //
          // 	console.log(vm.$store.state.automation.automationList[data.ind]);
          // }

          vm.$store.state.automation.automationList[data.ind].actions.push(
            action
          );
        });
      }
      this.isShowActionEditPopOver = false;
      $("ul.dropdown-menu").removeClass("show");

      // $('ul.dropdown-menu').dropdown('hide')
      // this.stopClosingDropDown()
    },
    stopClosingDropDown(event, check) {
      this.ispopUpOpenend = false;
      this.isEditConditionPopOver = false;
      this.isShowActionEditPopOver = false;
      this.isActionConditionConditinPopOver = false;
      if (check) {
        event.stopPropagation();
      } else {
        $(document).on("click", "ul.dropdown-menu", function (e) {
          e.stopPropagation();
        });
      }
    },
    getPreFilledTypeListFromTriggers(triggersList) {
      var typeList = [];
      for (var i = 0; i < triggersList.length; i++) {
        if (triggersList[i].trigger != "undefined") {
          typeList.push(
            JSON.parse(triggersList[i].trigger).trigger
              ? JSON.parse(triggersList[i].trigger).trigger.type
              : JSON.parse(triggersList[i].trigger).type
          );
        }
      }
      return typeList;
    },
    buttonToShow(automation) {
      let data = JSON.parse(automation.target);
      console.log(automation);
      let list = this.conditionList.filter(
        (res) => res.entity_type == data.name
      );
      if (list && list.length) {
        let totalConditionList = JSON.parse(list[0].attr_label);
        if (totalConditionList.length == automation.trigger.length) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }

      return true;
    },
    isJsonCheck(data) {
      try {
        JSON.parse(data);
      } catch (e) {
        return false;
      }
      return true;
    },
    getScopeList(scope) {
      let data = this.isJsonCheck(scope.scope_values)
        ? JSON.parse(scope.scope_values)
        : [];
      let isfileRef = false;
      if (
        scope.file_ref != null &&
        scope.file_ref != undefined &&
        scope.file_ref != "null"
      ) {
        isfileRef = this.isJsonCheck(scope.file_ref);
      }
      let arr = [];
      if (data.length) {
        if (data.length > 5) {
          arr = data.slice(0, 5);
        } else {
          arr = data;
        }
        let values = arr.map((res, index) => {
          return res.name
            ? res.name
            : res.type == "add asin"
            ? res.asin
            : res.product_title
            ? res.product_title
            : res.asin;
        });
        return values.join(", ");
      } else if (isfileRef) {
        // let fileRef = JSON.parse(scope.file_ref)
        // let values = []
        // fileRef.map((res, index) => {
        // 	let str = res.name;
        // 	let e = document.getElementById("scopes");
        // 	var a = document.createElement('a');
        // 	a.href(res.downloadUrl);
        // 	a.title(res.name)
        // 	e.appendChild(a)
        // //	values.push(result)
        // })

        return true;
      } else {
        return "All Selected";
      }
    },
    isShowMore(scope) {
      if (scope && scope.scope_values) {
        let data = this.isJsonCheck(scope.scope_values)
          ? JSON.parse(scope.scope_values)
          : [];
        if (data.length && data.length > 5) {
          return "true";
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    scopeTypeLabel(scope) {
      switch (scope) {
        case "Vendor":
          return "Vendors";
          break;
        case "Profile":
          return "Brand Profile";
          break;
        case "CampaignGroup":
          return "Campaign Group";
          break;
        case "Campaign":
          return "Campaign";
          break;
        case "Keyword":
          return "Keyword";
          break;
        case "Product":
          return "Product/Asin";
          break;
        case "Import File":
          return "Import File";
          break;
        case "all":
          return "Scope";
          break;
      }
    },
    deleteScopeUpdation(data, index) {
      let scopeData = this.automationList[index].scopeList;
      let toDelIndex = scopeData.findIndex(
        (res) => res.automation_scope == data.tag
      );
      scopeData.splice(toDelIndex, 1);
      this.automationList[index].scopeList = scopeData;
    },
    editScope(data, index) {
      let scopeData = this.automationList[index].scopeList;
      let toDelIndex = scopeData.findIndex(
        (res) =>
          JSON.stringify(res.automation_scope) == JSON.stringify(data.tag)
      );
      scopeData.splice(toDelIndex, 1);
      let obj = {
        active: true,
        automation_scope: data.tag,
        id: data.id,
        scope_values: JSON.stringify(data.list),
      };
      scopeData.push(obj);
      this.automationList[index].scopeList = scopeData;
    },
    saveScope(data, index) {
      let scopeData = this.automationList[index].scopeList;
      let isImportProduct = scopeData.map((e, index) => {
        if (e.automation_scope == "Import File") {
          return index;
        }
      });

      isImportProduct = isImportProduct.filter((e) => e != undefined);

      let isProduct = scopeData.map((e, index) => {
        if (e.automation_scope == "Product") {
          return index;
        }
      });

      isProduct = isProduct.filter((e) => e != undefined);

      if (isImportProduct.length && data.selectedType == "Import File") {
        scopeData.splice(isImportProduct[0], 1);
      }
      if (isProduct.length && data.selectedType == "Product") {
        scopeData.splice(isProduct[0], 1);
      }
      let scope_values = "";
      if (data.selectedType == "Keyword") {
        scope_values = JSON.stringify(data.selectedKeywords);
      } else if (data.selectedType == "Import File") {
        scope_values = [];
      } else {
        scope_values = JSON.stringify(data.selectedOptions);
      }
      let obj = {
        scope_values: scope_values,
        active: true,
        automation_scope: data.selectedType,
      };
      if (data.selectedType == "Import File") {
        obj.file_ref = JSON.stringify(data.file_ref);
      }
      scopeData.push(obj);
      this.automationList[index].scopeList = JSON.parse(
        JSON.stringify(scopeData)
      );
    },
    buttonToShowActions(automation) {
      let data = JSON.parse(automation.target);
      let list = this.actionList.filter((res) => res.type == data.name);
      if (list.length == automation.actions.length) {
        return false;
      } else {
        return true;
      }
    },
    getexecutionTimeVal(data, automation) {
      // execute_on
      data = JSON.parse(data);
      let values = data.map((res) => {
        return res.name;
      });
      if (JSON.parse(automation.execute_on || "{}").name == "Monthly") {
        values.sort((a, b) => (a > b ? 1 : b > a ? -1 : 0));

        values = values.map(date=>{
          if(date=='1'){
            return '1st'
          }
          else if(date=='2'){
            return '2nd'
          }
          else if(date=='3'){
            return '3rd'
          }
          else{
            return date?date+'th':''
          }
        }).join(", ");
        return " on the " + values;
      } else if (JSON.parse(automation.execute_on).name == "Weekly") {
        values.sort((a, b) =>
          moment(a, "ddd dddd").weekday() > moment(b, "ddd dddd").weekday()
            ? 1
            : moment(b, "ddd dddd").weekday() > moment(a, "ddd dddd").weekday()
            ? -1
            : 0
        );
        values = values.join(", ");
        return " on " + values;
      } else {
        values = values.join(",");
        return values;
      }
    },
    addConditionsPopOver(
      id,
      target,
      index,
      conditionIndex,
      triggersList,
      operation_type
    ) {
      this.toggleModal();
      this.ispopUpOpenend = true;
      this.indexToShowOnPopUpClick = index;
      this.preFilledTypeList =
        this.getPreFilledTypeListFromTriggers(triggersList);
      this.currentSelectedIndex = index;
      this.editAutomationId = id;
      this.addCondition = true;
      this.currentConditionIndex = conditionIndex;
      this.currentIndex = index;
      this.callAddEditConditionModal = true;
      this.editConditionTarget = JSON.parse(target);
      this.operationType =
        triggersList && triggersList[0] && triggersList[0].operation_type
          ? triggersList[0].operation_type
          : operation_type
          ? operation_type
          : "";
      this.$nextTick(() => {
        window.$("#addEditCondition").modal({
          show: true,
        });
      });
    },
    editConditionByIndex(
      data,
      target,
      index,
      conditionIndex,
      id,
      triggersList
    ) {
      this.toggleModal();

      this.currentSelectedIndex = index;
      this.isEditConditionPopOver = true;
      this.editConditionSelected = conditionIndex;
      this.showByIndexCondition = false;
      this.ispopUpOpenend = true;
      this.indexToShowOnPopUpClick = index;

      this.preFilledTypeList =
        this.getPreFilledTypeListFromTriggers(triggersList);
      this.editCondition = true;
      this.editConditionRow = JSON.parse(data);
      this.conditionRowId = id;
      this.currentConditionIndex = conditionIndex;
      this.currentIndex = index;
      this.callAddEditConditionModal = true;
      this.editConditionTarget = JSON.parse(target);
      this.$nextTick(() => {
        window.$("#addEditCondition").modal({
          show: true,
        });
      });
    },
    updateContionList(trigger, isEdit) {
      let obj =
        this.automationList[this.currentSelectedIndex].trigger[
          this.currentConditionIndex
        ];
      obj.trigger = JSON.stringify(trigger[0]);
      if (isEdit) {
        this.automationList[this.currentSelectedIndex].trigger.splice(
          this.currentConditionIndex,
          1,
          obj
        );
      }
    },
    AddConditionsListUIUpdate(data) {
      this.automationList[this.currentSelectedIndex].trigger[0].operation_type =
        data[0].operation_type;
      this.automationList[this.currentSelectedIndex].trigger = [
        ...this.automationList[this.currentSelectedIndex].trigger,
        ...data,
      ];
    },
    showConditionEditLoader() {
      // this.showEditConditionLoaderVal = true
    },
    hideConditionEditLoader() {
      // this.showEditConditionLoaderVal = false
    },
    toggleModal() {
      this.ispopUpOpenend = false;
      this.preFilledTypeList = [];
      this.callScopeModal = false;
      this.conditionRowId = "";
      this.addCondition = false;
      this.editCondition = false;
      this.editConditionTarget = "";
      this.editConditionRow = "";
      this.callActionModal = false;
      this.callAssociateModal = false;
      this.callAddEditModal = false;
      this.callAddEditConditionModal = false;
      this.editAutomationId = "";

      /* this.currentIndex = -1;
										  this.currentActionIndex = -1; */
    },
    openAddEditAutomation(index) {
      this.toggleModal();
      this.editAutomationId = this.automationList[index].id;

      this.$router.push({
        path: `/addEditGuardrail/${this.editAutomationId}${this.$route.fullPath}`,
      });
      // (this.callAddEditModal = true),
      // 	this.$nextTick(() => {
      // 		window.$("#addEditAutomation").modal({
      // 			show: true
      // 		});
      // 	});
    },

    openAssociateAutomation(index) {
      let var1 = AssociateAutomation;
      this.toggleModal();
      this.associateAutomationId = this.automationList[index].id;
      this.automationIndex = index;
      this.automationTarget = JSON.parse(
        this.automationList[index].target
      ).name;
      this.callAssociateModal = true;
      this.$nextTick(() => {
        window.$("#associateAutomation").modal({
          show: true,
        });
      });
      //$('#associate_toggle_' + index).popover('show')
    },
    openTemplatePopUp(data, index) {
      this.templateSelected = data.id;
      this.oldTemplate = data.template_id;
      this.selectedTemplateIndex = index;
      $("#selectTemplate").modal("show");
    },
    closeTemplateModal(val, addedData) {
      this.templateSelected = "";
      this.oldTemplate = "";
      if (val != "cancel") {
        if (addedData) {
          let data = JSON.parse(JSON.stringify(this.automationList));
          data[this.selectedTemplateIndex].template_name =
            addedData.template_name;
          data[this.selectedTemplateIndex].template_id = addedData.template_id;
          //	this.automationList = JSON.parse(JSON.stringify(data))

          this.$store.state.automation.automationList[
            this.selectedTemplateIndex
          ] = data[this.selectedTemplateIndex];
        }
      }
      $("#selectTemplate").modal("hide");
      this.selectedTemplateIndex = -1;
    },
    openAutomationActions(action, index, actionIndex, isEdit, target) {
      this.isShowActionEditPopOver = true;
      this.showActionIndexPopOver = actionIndex;
      this.indexToShowOnPopUpClick = index;
      this.toggleModal();
      this.ispopUpOpenend = true;
      this.automationGridId = index;
      this.currentIndex = index;
      this.currentActionIndex = actionIndex;
      const vm = this;
      var pay = {
        type: JSON.parse(target).name,
      };
      // this.$store.dispatch("automation/getActionTypeList",pay).then(res=>{
      // 	vm.oldActionTypeList = res;
      // 	vm.callActionModal = true;
      // });

      vm.callActionModal = true;
      if (isEdit == true) {
        this.$store.state.isEdit = true;
        this.actionToEdit = action;
      } else this.$store.state.isEdit = false;
    },
    confirmDeleteAction(data, actionIndex, index) {
      this.actionToDel = data.id;
      this.currentActionIndex = actionIndex;
      this.currentSelectedIndex = index;
      $("#confirmSingleDeleteProduct").modal("show");
    },
    deleteAction() {
      this.guardrailName = "";
      //this.showLoader = true;
      let vm = this;
      let payload = {};
      if (this.actionToDel != -1) {
        payload = {
          id: this.actionToDel,
          type: "action",
        };
        this.showDelLoader = true;
      } else if (this.guardRailId != -1) {
        payload = {
          id: this.guardRailId,
          type: "guardrail",
        };
        this.automationList[
          this.currentSelectedIndex
        ].showGuardRailLoader = true;
      } else {
        payload = {
          id: this.conditionToDel,
          type: "condition",
        };
        this.showDelLoader = true;
      }
      this.$store.dispatch("automation/DelAction", payload).then((res) => {
        if (vm.actionToDel != -1) {
          vm.automationList[vm.currentSelectedIndex].actions.splice(
            vm.currentActionIndex,
            1
          );
          vm.showDelLoader = false;
        } else if (vm.guardRailId != -1) {
          vm.automationList[
            vm.currentSelectedIndex
          ].showGuardRailLoader = false;
          vm.automationList.splice(vm.currentSelectedIndex, 1);
        } else {
          vm.automationList[vm.currentSelectedIndex].trigger.splice(
            vm.currentConditionIndex,
            1
          );
          vm.showDelLoader = false;
        }
        vm.actionToDel = -1;
        vm.conditionToDel = -1;
        vm.currentActionIndex = -1;
        vm.currentSelectedIndex = -1;
        vm.currentConditionIndex = -1;
        vm.guardRailId = -1;
        vm.guardrailName = "";
        // this.$store.dispatch("automation/getAutomations").then(res => {
        //   this.showLoader = false;
        //
        // });
      });
    },

    confirmDeleteCondition(data, conditionIndex, index) {
      this.conditionToDel = data.id;
      this.currentSelectedIndex = index;
      this.currentConditionIndex = conditionIndex;
      $("#confirmSingleDeleteProduct").modal("show");
    },
    ShowDetailedScope(scope) {
      let data = JSON.parse(scope.scope_values);
      this.selectedShowMoreScopeTarget = this.scopeTypeLabel(
        scope.automation_scope
      );
      this.selectedShowMoreScopeData = data;
      window.$("#detailedScopeData").modal({
        show: true,
      });
    },
    closePopUp() {
      this.previewTemplateData = {};
      $("#previewModal").modal("hide");
    },
    openPreviewPopUp(data) {
      this.previewTemplateData = data;
      $("#previewModal").modal("show");
    },
  },
};
</script>

<style lang="scss">

.guard_rect {
  box-sizing: border-box !important;
  height: 78px !important;
  width: 129px !important;
  border: 1px solid #979797 !important;
  border-radius: 3px !important;
  background-color: #ffffff !important;
  padding: 2px 0px 13px 0px !important;
  margin: 0px !important;
  min-width: 129px !important;
  max-width: 129px !important;

  .sub_menu {
    line-height: 14px !important;
    padding-left: 10.5px !important;
    color: #000000 !important;
    font-family: Roboto !important;
    font-size: 12px !important;
    letter-spacing: -0.03px !important;
    padding-top: 7px !important;
    padding-bottom: 0px !important;
  }
}
.active_color {
  background: linear-gradient(180deg, #abf2c0 0%, #b7dd79 100%);
}
.disabled_color {
  background: linear-gradient(180deg, #fb9d95 0%, #c93f26 100%);
}
.draft_color {
  background: linear-gradient(180deg, #fadda2 0%, #ffbf3f 100%);
}
.showvisibility {
  visibility: visible !important;
}
.btn.btn-primary.align-bottom {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}
.btn.btn-primary.curve {
  border-radius: 4px !important;
}
.menuPadding {
  padding: 0px !important;
}

.rule_wrapper,
.table tbody tr.rule_wrapper:hover {
  background-color: #e8e8e8 !important;
  text-decoration: none;
}
</style>
